import React, { useEffect, useMemo, useRef, useState } from 'react'
import { AutoComplete, Button, DatePicker, Flex, Form, Input, Modal, Select } from 'antd'
import './AddRelative.scss'
import * as  selectOptionsApi from '../../../api/selectOptions/selectOptionsApi'
import { fommatSelectOption, handleDateChangeDayJs } from '../../../until'
import dayjs from "dayjs";
import useToast from '../../../hook/useToast'
import { useForm } from 'antd/es/form/Form'
import useThrottle from '../../../hook/useThrottle'
import useDebounce from '../../../hook/useDebounce'
import { getInfoBusiness, getInfoBusiness_V2, IBusiness } from '../../../api/business/businessApi'
import { selectorInfoUser } from '../../../store/slices/infoUserSlice'
import { useSelector } from 'react-redux'
import { PhoneOutlined, PlusSquareOutlined } from '@ant-design/icons'
import { icon_delelte } from '../../../components/ExportImgFigma'
import { IRelativeBusinessADD } from './AddBusiness'
import { IPhone } from '../../../api/relatives/relativesApi'
import { IRelativeBusinessADD_V2 } from './AddBusinessAddCustomer'
import { InforSelectedCodeCustomer } from './AddRelativeAddCustomer'
import { NO_DATA } from '../../../env'
import { selectorCategoryCarIds } from '../../../store/slices/categoryCarSlice'
import useLoading from '../../../hook/useLoading'

interface Props {
  show: boolean
  index?: number
  infoBusiness?: IRelativeBusinessADD_V2
  modalClose?: () => void
  onSubmitFormModal?: (iSsuccess: boolean, message?: string) => void
  handleUpdateListBusiness: (index: number, infoBusiness: IRelativeBusinessADD_V2) => void
}

const UpdateBusinessAddCustomer_V2: React.FC<Props> = (props) => {
  const {
    show, index, infoBusiness,
    modalClose, onSubmitFormModal, handleUpdateListBusiness
  } = props

  const formRef: any = useRef(null)
  const [form] = useForm()
  const pushToast = useToast();
  const pushLoading = useLoading();

  const { unitTemp } = useSelector(selectorInfoUser)
  const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)

  const [sLTaxCodeBusiness, setSLTaxCodeBusiness] = useState<selectOptionsApi.ITag_V2[]>([])
  const [sLBusinessRelationship, setSLBusinessRelationship] = useState<selectOptionsApi.ISelectOption[]>([])
  const [sLBusinessField, setSLBusinessField] = useState<selectOptionsApi.ISelectOption[]>([])
  const [sLProvice, setSLProvice] = useState<selectOptionsApi.ISelectOption[]>([])
  const [sLDistrict, setSLDistrict] = useState<selectOptionsApi.ISelectOption[]>([])
  const [sLTypePhone, setSLTypePhone] = useState<selectOptionsApi.ISelectOption[]>([])

  const [phoneTypeTmp, setPhoneTypeTmp] = useState<{ [key: number]: number }>({})
  const [isSelectedTaxCode, setIsSelectedTaxCode] = useState(false)

  const [inforSelectedCodeCustomer, setInforSelectedCodeCustomer] = useState<InforSelectedCodeCustomer>()
  const [infoRelativeBusinessTmp, setInfoRelativeBusinessTmp] = useState<IRelativeBusinessADD_V2>()

  const [paginationCodeBusiness, setPaginationCodeBusiness] = useState({ current: 1, pageSize: 30, total: 0 });

  const isDisable = useMemo(() => {
    return inforSelectedCodeCustomer?.id !== undefined;
  }, [inforSelectedCodeCustomer]);

  const gSLTaxCodeBusiness = useDebounce(async (current: number = 1, search?: string) => {
    pushLoading(true)
    const result = await selectOptionsApi.getCLTaxCodeBusiness(
      permittedCategoryCarIds,
      undefined, search, unitTemp ?? undefined, 30, current
    );
    if (result?.status) {
      setSLTaxCodeBusiness(prev =>
        current === 1
          ? result.data                // load lần đầu
          : [...prev, ...result.data]  // append
      );

      setPaginationCodeBusiness(prev => ({
        ...prev,
        current,
        total: result.total || 0
      }));
    } else {
      pushToast(result?.message, "error")
    }
    pushLoading(false)
  }, 1000)

  const gSBusinessRelationship = async () => {
    pushLoading(true)
    const result = await selectOptionsApi.getListRelatives();
    if (result?.status) {
      setSLBusinessRelationship(fommatSelectOption(result.data))
    } else {
      pushToast(result?.message, "error")
    }
    pushLoading(false)
  }

  const gSLsetSLBusinessField = async () => {
    pushLoading(true)
    const result = await selectOptionsApi.getBusinessField();
    if (result?.status) {
      setSLBusinessField(fommatSelectOption(result.data))
    } else {
      pushToast(result?.message, "error")
    }
    pushLoading(false)
  }

  const gSLProvice = async () => {
    pushLoading(true)
    const result = await selectOptionsApi.getListProvince();
    if (result?.status) {
      setSLProvice(fommatSelectOption(result.data))
    } else {
      pushToast(result?.message, "error")
    }
    pushLoading(false)
  }


  const gSLTypePhone = async () => {
    pushLoading(true)
    const result = await selectOptionsApi.getListTypePhone();
    if (result?.status) {
      setSLTypePhone(fommatSelectOption(result.data))
    } else {
      pushToast(result?.message, "error")
    }
    pushLoading(false)
  }

  const gInfoBusinessr = async (taxCode: string) => {
    pushLoading(true)
    form.resetFields()
    const result = await getInfoBusiness_V2(undefined, taxCode)
    if (result?.status) {
      const { email, businessName, phoneBusiness, profession, businessRelationship } = result.data

      const validEmail = email?.map(email => ({ email }));
      form.setFieldsValue({
        "taxCode": taxCode,
        "businessName": businessName,
        "phone": phoneBusiness,
        "professionId": profession?.id,
        "email": validEmail,
        "businessRelationshipId": infoBusiness?.businessRelationshipId
      });
    } else {
      pushToast(result?.message, "error")
    }
    pushLoading(false)
  }

  const handleSelectCodeCustomer = (value: InforSelectedCodeCustomer) => {
    if (value.value)
      gInfoBusinessr(value.value)

    setInforSelectedCodeCustomer(value)
  }

  const onPopupScroll = (e: any) => {
    const target = e.target;
    const isBottom =
      target.scrollTop + target.clientHeight >= target.scrollHeight - 20;
    if (!isBottom) return;

    const { current, total } = paginationCodeBusiness;

    const hasMore = sLTaxCodeBusiness.length < total;

    if (!hasMore) return;
    gSLTaxCodeBusiness(current + 1);
  };

  const onFormFinish = (values: any) => {
    confimSubmit(values)
  }

  const confimSubmit = useThrottle(async (values: any) => {
    const { taxCode, businessName, phone, professionId, email, businessRelationshipId } = values

    let inforSelectedCodeCustomerTmp: InforSelectedCodeCustomer = inforSelectedCodeCustomer?.id ?
      inforSelectedCodeCustomer : { value: taxCode }

    const validEmail = email.map((item: any) => item?.email).filter((email: any) => typeof email === "string" && email.trim() !== "");

    const newInfoRelative = {
      inforSelectedCodeCustomer: inforSelectedCodeCustomerTmp,
      businessName: businessName,
      phone,
      email: validEmail,
      professionId: professionId,
      businessRelationshipId: businessRelationshipId,
      unitTempId: unitTemp
    } as IRelativeBusinessADD_V2

    handleUpdateListBusiness?.(Number(index), newInfoRelative)

  }, 2000)



  useEffect(() => {
    if (inforSelectedCodeCustomer?.id) {
      gInfoBusinessr(inforSelectedCodeCustomer.value ?? "")
    }
  }, [inforSelectedCodeCustomer])

  useEffect(() => {
    if (infoBusiness && show) {
      const { email, inforSelectedCodeCustomer, phone, professionId, businessName, businessRelationshipId, unitTempId } = infoBusiness
      if (inforSelectedCodeCustomer?.id) {
        setInforSelectedCodeCustomer(inforSelectedCodeCustomer)
      } else {
        const validEmail = email?.map(email => ({ email }));
        form.setFieldsValue({
          "taxCode": inforSelectedCodeCustomer.value,
          "businessName": businessName,
          "phone": phone,
          "professionId": professionId,
          "email": validEmail,
          "businessRelationshipId": infoBusiness?.businessRelationshipId
        });
      }
    }
  }, [infoBusiness])

  useEffect(() => {
    if (show) {
      // if (!sLRelative.length)
      gSLTaxCodeBusiness()
      if (!sLBusinessRelationship.length)
        gSBusinessRelationship()
      if (!sLBusinessField.length)
        gSLsetSLBusinessField()
      if (!sLProvice.length)
        gSLProvice()
      if (!sLTypePhone?.length)
        gSLTypePhone()
    } else {
      form.resetFields()

      setInforSelectedCodeCustomer(undefined)
    }
  }, [show])

  return (

    <Modal
      open={show}
      title='Chỉnh sửa doanh nghiệp'
      className='rs-modal w-572 footer-content-end add-relative-modal'
      centered
      footer={
        <Button
          type='primary'
          className='rs-button rs-button--sm'
          onClick={() => formRef?.current.submit()}
        >Lưu</Button>
      }
      onCancel={modalClose}
    >
      <Form
        ref={formRef}
        form={form}
        className='rs-form add-relative-form'
        onFinish={onFormFinish}
      >

        <div className="d-flex flex-column gap-1">
          <p className="text-sm  font-regular text-344054 d-flex gap-2 align-center">
            Mã số thuế
            <div>
              <span className="text-F5222D">*</span>
              :
            </div>

          </p>
          <Form.Item
            layout='vertical'
            // label="Mã số thuế:"
            name="taxCode"
            rules={[{ required: true, message: 'Vui lòng nhập mã số thuế' }]}
          >
            <AutoComplete
              placeholder="Nhập mã số thuế"
              disabled={isDisable}
              onPopupScroll={onPopupScroll}
              options={sLTaxCodeBusiness.map((item) => ({
                key: item.id,
                value: item.taxCode,         // Giá trị hiển thị trong ô tìm kiếm
                label: `${(item.taxCode ?? NO_DATA)} - ${item.username}`, // Gợi ý hiển thị dropdown
                id: item.id,              // Giá trị thực tế bạn muốn lấy khi chọn       // Giá trị thực tế bạn muốn lấy khi chọn
              }))}
              filterOption={(inputValue, option) =>
                !!option?.value?.toLowerCase().includes(inputValue.toLowerCase())
              }
              onSelect={(value, option) => {
                handleSelectCodeCustomer(option)
              }}
            >
              <Input className="custom-input-css custom-page-css border" />
            </AutoComplete>
          </Form.Item>
        </div>
        <div className="d-flex flex-column gap-1">
          <p className="text-sm  font-regular text-344054 d-flex gap-2 align-center">
            Tên doanh nghiệp
            <div>
              <span className="text-F5222D">*</span>
              :
            </div>

          </p>
          <Form.Item
            layout='vertical'
            name='businessName'
            rules={[
              { required: true, message: "Vui lòng nhập tên doanh nghiệp" }
            ]}
          >
            <Input
              disabled={isDisable}
              placeholder='Tên doanh nghiệp'
              className='custom-input-css custom-page-css border'
            />
          </Form.Item>
        </div>
        <div className="d-flex flex-column gap-1">
          <p className="text-sm  font-regular text-344054 d-flex gap-2 align-center">
            Số điện thoại
            <div>
              <span className="text-F5222D">*</span>
              :
            </div>
          </p>
          <Form.List
            name="phone"
            initialValue={[{ phone: "", categoryPhoneId: null }]}
          >
            {
              (fields, { add, remove }) => (
                <Flex vertical className="gap-10px">
                  {
                    fields.map((field) => (
                      <div key={field.key} className="d-flex gap-1">
                        {/* shouldUpdate để đọc trạng thái categoryPhoneId của từng dòng */}
                        <Form.Item noStyle shouldUpdate>
                          {
                            ({ getFieldValue }) => {
                              const selected = getFieldValue(["phone", field.name, "categoryPhoneId",]);

                              return (
                                <Form.Item
                                  className="w-full"
                                  name={[field.name, "phone"]}
                                  rules={[
                                    { required: true, message: "Vui lòng nhập số điện thoại" },
                                    () => ({
                                      validator(_, value) {
                                        if (!value) return Promise.resolve();

                                        const phoneType = getFieldValue(["phone", field.name, "categoryPhoneId",]);

                                        if (!phoneType) return Promise.resolve();

                                        const isHome = phoneType === 1;
                                        const isCompany = phoneType === 2;

                                        if (isHome && !/^0\d{9}$/.test(value)) {
                                          return Promise.reject(
                                            new Error(
                                              "Số điện thoại không hợp lệ (10 số, bắt đầu bằng 0)"
                                            )
                                          );
                                        }

                                        if (isCompany && !/^0\d{10,11}$/.test(value)) {
                                          return Promise.reject(
                                            new Error(
                                              "Số điện thoại không hợp lệ (11-12 số, bắt đầu bằng 0)"
                                            )
                                          );
                                        }
                                        return Promise.resolve();
                                      },
                                    }),
                                  ]}
                                >
                                  <Input
                                    prefix={<PhoneOutlined />}
                                    placeholder="Số điện thoại"
                                    className="custom-input-css custom-page-css border"
                                    type="tel"
                                    disabled={!selected || isDisable} // Chỉ nhập khi đã chọn loại điện thoại
                                  />
                                </Form.Item>
                              );
                            }}
                        </Form.Item>
                        <Form.Item
                          name={[field.name, "categoryPhoneId"]}
                          rules={[{ required: true, message: "Vui lòng chọn loại điện thoại" }]}
                        >
                          <Select
                            disabled={isDisable}
                            options={sLTypePhone}
                            placeholder="Loại điện thoại"
                            className="custom-page-css border rounded overflow-hidden w-150-px"

                            onChange={(val) => {
                              // Nếu bỏ chọn => xóa luôn số điện thoại
                              if (val == null) {
                                const curr = (form?.getFieldValue?.("phone") ?? []).slice();
                                if (curr[field.name]) curr[field.name].phone = "";
                                form?.setFieldsValue?.({ phone: curr });
                              }
                            }}
                          />
                        </Form.Item>
                        <img
                          hidden={fields.length <= 1}
                          src={icon_delelte}
                          alt=""
                          className={`${isDisable ? "d-none" : "rounded-6-px border-f2f4f7 p-7-px bg-white cursor-pointer"}`}
                          onClick={() => remove(field.name)} // dùng field.name an toàn hơn index
                        />
                      </div>
                    ))
                  }
                  <div
                    className={`${isDisable ? "d-none" : "d-flex align-center gap-1 cursor-pointer text-1890FF pt-1 w-fit"}`}
                    onClick={() => add({ phone: "", categoryPhoneId: null })}
                  >
                    <PlusSquareOutlined className="text-sm" />
                    <span className="text-sm">Thêm số điện thoại mới</span>
                  </div>
                </Flex>
              )
            }
          </Form.List>
        </div>
        <Form.Item
          layout='vertical'
          label='Ngành nghề kinh doanh :'
          name='professionId'
        >
          <Select
            disabled={isDisable}
            placeholder='Ngành nghề kinh doanh'
            className='custom-page-css border rounded overflow-hidden'

            options={sLBusinessField}
          />
        </Form.Item>
        <div className="d-flex flex-column gap-1">
          <p className="text-sm  font-regular text-344054 d-flex gap-2 align-center">
            Email :
          </p>
          <Form.List
            name="email"
            initialValue={[{}]}
          >
            {(fields, { add, remove }) => (
              <div className='d-flex flex-column gap-1'>
                {fields.map((field, i) => (
                  <div key={field.key} className="d-flex gap-2">

                    <Form.Item
                      name={[field.name, 'email']}
                      fieldKey={[i, "email"]}
                      className="m-none-form-item text-explan w-full"
                      rules={[
                        {
                          type: 'email',
                          message: 'Email không hợp lệ',
                          // validateTrigger: 'onBlur',
                        },
                      ]}
                    >
                      <Input
                        disabled={isDisable}
                        placeholder="Email"
                        className="custom-input-css custom-page-css border"
                      />
                    </Form.Item>
                    <img
                      hidden={fields.length <= 1}
                      src={icon_delelte}
                      alt=""
                      className={` ${isDisable ? "d-none" : "rounded-6-px border-f2f4f7 p-7-px bg-white cursor-pointer"}`}
                      onClick={() => remove(i)}
                    />
                  </div>
                ))}
                <div
                  className={` ${isDisable ? "d-none" : "d-flex align-center gap-1 cursor-pointer text-1890FF pt-1 w-fit"} `}
                  onClick={() => add({})}
                >
                  <PlusSquareOutlined className="text-sm" />
                  <span className="text-sm">Thêm mail mới</span>
                </div>
              </div>
            )}
          </Form.List>
        </div>

        <Form.Item
          layout='vertical'
          label='Mối quan hệ :'
          name='businessRelationshipId'
          rules={[
            { required: true, message: "Vui lòng chọn mối quan hệ" }
          ]}
        >
          <Select
            placeholder='Mối quan hệ'
            className='custom-page-css border rounded overflow-hidden'

            options={sLBusinessRelationship}
          />
        </Form.Item>
      </Form>
    </Modal >
  )
}

export default UpdateBusinessAddCustomer_V2
